<div class="cs-d-flex flex-column conditional-container p-15">
    <label class="control-label required_field">Add condition of "{{ activeConditionalField['text'] }}"</label>
    <div class="cs-d-flex" [formGroup]="conditionForm">
        <div class="cs-flex-1 mr-10">
            <select class="" formControlName="operator" (change)="onSelectOperator()">
                <option value="">Please.Choose</option>
                <option *ngFor="let opt of activeConditionalField['operators']" value="{{opt}}">{{operators[opt]}}</option>
            </select>
        </div>
        <div class="cs-flex-1" [ngSwitch]="true">
            <div *ngSwitchCase="activeConditionalField.input === 'select' || activeConditionalField.input === 'checkboxList'">
                <ng-container *ngIf="!['in', 'not_in'].includes(conditionForm.get('operator').value)">
                    <select class="" formControlName="value">
                        <option value="">Please.Choose</option>
                        <option *ngFor="let option of activeConditionalField.options" value="{{option.id}}">{{option.text}}</option>
                    </select>
                </ng-container>
                <ng-container *ngIf="['in', 'not_in'].includes(conditionForm.get('operator').value)">
                    <input
                       formControlName="value"
                       id="conditional_multiple_select"
                       (onChange)="onSelectMultipleSelect($event)"
                       ($instance)="setSelect2Instance($event)"
                       [attr.disabled]="isReadOnlyMode ? '' : null"
                       csSelect2
                       [select2Config]="{
                          multiple: true,
                            data: {
                              text: dataFunction,
                              results : activeConditionalField.options
                            }
                       }" class="full-width-select2"/>
                </ng-container>
            </div>
            <div *ngSwitchCase="activeConditionalField.input === 'number'">
                <input [attr.disabled]="isReadOnlyMode ? '' : null" type="text" formControlName="value" class="control-input text-input-height" appDigitDecimaNumber/>
            </div>
            <div  *ngSwitchCase="activeConditionalField.input === 'text'">
                <input [attr.disabled]="isReadOnlyMode ? '' : null" formControlName="value" type="text" class="control-input"/>
            </div>
        </div>
    </div>
</div>
